var files = require.context('../../../images/svg', false, /\.svg$/);
files.keys().forEach(files);

export default files;
